<!-- profile-dialog.component.html -->
<div class="profile-dialog-container">
  @if (data.isSmallerScreen) {
    <div class="profile-header">
      <h3>{{data.fullName}}</h3>
    </div>
  }

  <div class="menu-items">
    <div class="menu-item" tabindex="0" (click)="openProfile()" (keydown.enter)="openProfile()" (keydown.space)="openProfile()">
      <span class="item-text pt-1"><img class="pe-1" src="svg/profile_icons/profile.svg" alt="Profile Icon" />&nbsp;&nbsp;Profile</span>
    </div>
    <div class="menu-item" tabindex="0" (click)="openAccountInfo()" (keydown.enter)="openAccountInfo()" (keydown.space)="openAccountInfo()">
      <span class="item-text pt-1"><img class="pe-1" src="svg/profile_icons/account_info.svg" alt="Account Info Icon" />&nbsp;&nbsp;Account Info</span>
    </div>
    <div class="menu-item" tabindex="0" (click)="changePassword()" (keydown.enter)="changePassword()" (keydown.space)="changePassword()">
      <span class="item-text pt-1"><img class="pe-1" src="svg/profile_icons/change_password.svg" alt="Change Password Icon" />&nbsp;&nbsp;Change Password</span>
    </div>
    @if (isSettingsVisible()) {
      <div class="menu-item" tabindex="0" (click)="openSettings()" (keydown.enter)="openSettings()" (keydown.space)="openSettings()">
        <span class="item-text pt-1"><img class="pe-1" src="svg/profile_icons/control_center.svg" alt="Settings Icon" />&nbsp;&nbsp;Control Center</span>
      </div>
    }
    <div class="menu-item" tabindex="0" (click)="logout()" (keydown.enter)="logout()" (keydown.space)="logout()">
      <span class="item-text pt-1"><img class="pe-1" src="svg/profile_icons/logout.svg" alt="Logout Icon" />&nbsp;&nbsp;Logout</span>
    </div>
  </div>

  <div class="profile-theme-preference">
    <div class="profile-theme-preference__copy">
      <mat-icon>{{ isDarkMode ? 'dark_mode' : 'light_mode' }}</mat-icon>
      <span><strong>Appearance</strong><small>{{ isDarkMode ? 'Dark mode' : 'Light mode' }}</small></span>
    </div>
    <button class="profile-theme-switch" type="button" role="switch" [attr.aria-checked]="isDarkMode"
      [attr.aria-label]="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'" (click)="toggleDarkMode()">
      <span></span>
    </button>
  </div>

  <div class="profile-footer">
    <div class="legal-links">
      <span class="cursor-pointer" tabindex="0" (click)="openPrivacyPolicy()" (keydown.enter)="openPrivacyPolicy()" (keydown.space)="openPrivacyPolicy()">Privacy</span> - <span class="cursor-pointer" tabindex="0" (click)="openTermsAndConditions()" (keydown.enter)="openTermsAndConditions()" (keydown.space)="openTermsAndConditions()">Terms & Conditions</span>
    </div>
    <div class="version-info">{{applicationVersion}}</div>
  </div>
</div>
